<template>
  <div id="cashierGoodsDetails">
    <div class="rc-title flex-between">
      <div>整单优惠</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content-wrap">
      <div class="row">
        <div
          @click="type = 2"
          class="center"
          :class="type == 2?'discountTabSelected':'discountTab'"
        >
          <img style="margin-right:10px" src="../../assets/icon/zdjm.png" alt />
          整单改价
        </div>
        <div
          @click="type = 3"
          class="center"
          :class="type == 3?'discountTabSelected2':'discountTab'"
        >
          <img style="margin-right:10px" src="../../assets/icon/zddz.png" alt />
          整单打折
        </div>
      </div>
      <div v-if="type == 2">
        <div style="margin-top:20px">请输入改价金额</div>
        <div class="buy">
          <input class="buyInput" v-model="reducePrice" />
        </div>
      </div>
      <div v-if="type == 3">
        <div style="margin-top:20px">请输入折扣（如8.5折请输入8.5）</div>
        <div class="buy">
          <input class="buyInput" v-model="discountNumber" />
        </div>
      </div>
      <div class="confirm">
        <el-button type="primary" @click="success">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: 2, //1整单减免 2整单打折
      discountNumber: 0,
      reducePrice: 0
    };
  },
  created() {},
  methods: {
    //选择商品 productId
    success() {
      if ( this.$store.state.offers.type == 1 || this.$store.state.offers.type == 4 ) {
          this.$confirm("当前已使用其他优惠, 不可与此优惠同时使用", "是否使用", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(({ value }) => {
            var isTrue = false;
            if ( this.type == 2 && this.reducePrice > Number(this.$store.state.cartListTotalPrice) + Number(this.$store.state.cartListDiscounts) ) {
              this.$message({
                type: "warning",
                message: "改价价格不能高于本单应收金额 "
              });
              return;
            }
            if ( (this.type == 3 && this.discountNumber <= 0) || this.discountNumber >= 10 ) {
              this.$message({
                type: "warning",
                message: "请输入正确的折扣，如8.5折输入8.5，范围(0~10)"
              });
              return;
            }
            if (this.type == 2 && this.reducePrice > 0) {
              isTrue = true;
            } else if ( this.type == 3 && this.discountNumber > 0 && this.discountNumber < 10 ) {
              isTrue = true;
            }
            if (isTrue) {
            } else {
              this.$message({
                type: "warning",
                message: "请输入正确数字"
              });
              return;
            }
            this.$store.state.offers.type = this.type;
            this.$store.state.offers.discountNumber = this.discountNumber;
            this.$store.state.offers.reducePrice = this.reducePrice;
            this.$store.commit("countTotalPrice");
            this.$store.commit("countCartListPrice");
            this.$router.go(-1); //返回上一页
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "取消输入"
            // });
          });
        return;
      }
      var isTrue = true;
      console.log(this.$store.state.cartListTotalPrice, this.$store.state.cartListDiscounts, this.reducePrice, 11111111111)
      if ( this.type == 2 && this.reducePrice > Number(this.$store.state.cartListTotalPrice) + Number(this.$store.state.cartListDiscounts) ) {
        this.$message({
          type: "warning",
          message: "改价价格不能高于本单应收金额 "
        });
        return;
      }
      if (this.type == 2 && this.reducePrice < 0.01) {
        this.$message({
          type: "warning",
          message: "请输入正确数字"
        });
        return;
      }
      if ( (this.type == 3 && this.discountNumber <= 0) || this.discountNumber >= 10 ) {
        this.$message({
          type: "warning",
          message: "请输入正确的折扣，如8.5折输入8.5，范围(0~10)"
        });
        return;
      }
      this.$store.state.offers.type = this.type;
      this.$store.state.offers.discountNumber = this.discountNumber;
      this.$store.state.offers.reducePrice = this.reducePrice;
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
      this.$router.go(-1); //返回上一页
    },
    back() {
      this.$router.go(-1);
    },
    add() {
      this.$store.state.cartList.push({});
    }
  }
};
</script>
<style scoped>
.discountTabSelected2 {
  width: 170px;
  height: 64px;
  background: #f1f7ff;
  border-radius: 3px;
  font-size: 16px;
  margin-right: 10px;
}
.discountTabSelected {
  width: 170px;
  height: 64px;
  background: rgba(253, 248, 238, 1);
  border-radius: 3px;
  font-size: 16px;
  margin-right: 10px;
}
.discountTab {
  width: 170px;
  height: 64px;
  background: rgba(248, 248, 249, 1);
  border-radius: 3px;
  font-size: 16px;
  margin-right: 10px;
}
.buy {
  position: relative;
}
.unit {
  position: absolute;
  top: 20px;
  left: 110px;
  color: #999999;
}
.confirm {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
#cashierGoodsDetails {
  height: 100%;
  width: 100%;
}
.buyInput {
  width: 50px;
  padding: 12px 41px;
  margin-top: 10px;
}
.product2 {
  padding: 12px 41px;
  /* background: rgba(30, 148, 234, 1); */
  border: 1px solid rgba(30, 148, 234, 1);
  border-radius: 2px;
  color: rgba(30, 148, 234, 1);
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.product {
  padding: 12px 41px;
  background: rgba(30, 148, 234, 1);
  border: 1px solid rgba(16, 142, 233, 1);
  border-radius: 2px;
  color: #fff;
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.borderBottom {
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
}
.goodsSprice {
  color: #f92323;
}
.goodsName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.goodsText {
  margin-left: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.goodsImg img {
  height: 100px;
  width: 100px;
}
.content-wrap {
  padding: 23px 26px;
  font-size: 14px;
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderAllDiscount.vue